module.exports = __webpack_public_path__ + "static/product2-842c1b83e58c266f7c8710691ce5c2d5.png";